import React from 'react';
import { KFLDialog } from '@kamstrup/kamstrup-frontend-library';
import { setRightPanel } from '../../../modules/dialogs/actions';
import DialogHeader from '../../shared/dialog/dialogHeader';
import Translate from '../../shared/localization/localize';
import DialogSection from '../../shared/dialog/dialogSection';
import Tabs from '../../shared/tabs';
import {
  Activity,
  onTabChange,
  activityTabsData,
  TransferActivityTabs,
} from '../../../modules/dialogs/transfer';
import { Historical } from '../../../modules/historical/context';
import * as m from '../../../modules/dialogs/transfer/messages';
import { Activities } from './LogActivity';
import { useTxActivities } from '../../../modules/dialogs/transfer/useTxActivities';

const TxDialogActivitiesOpen: React.FC = () => {
  const {
    openTransfers,
    removeOpenLog,
    getMoreOpenLogs,
    getLatestOpenLogs,
  } = useTxActivities();
  const content = (
    <>
      <DialogSection>
        <Tabs
          tabs={activityTabsData}
          selectedTab={TransferActivityTabs.OPEN}
          onChange={onTabChange}
        ></Tabs>
      </DialogSection>
      <DialogSection isMain scrollable>
        <Historical<Activity>
          value={{
            historical: openTransfers,
            getLatestLogs: getLatestOpenLogs,
            getMoreLogs: getMoreOpenLogs,
            onRemoveLog: removeOpenLog,
          }}
        >
          <Activities />
        </Historical>
      </DialogSection>
    </>
  );

  return (
    <KFLDialog
      header={
        <DialogHeader
          title={<Translate message={m.msgHeaderActivities} />}
          fnCloseDialog={() => setRightPanel('')}
        />
      }
      sections={[content]}
    />
  );
};
export default TxDialogActivitiesOpen;
